import {
	Component,
	EventEmitter,
	forwardRef,
	Injectable,
	Input,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild
} from "@angular/core";
import * as moment from 'moment-timezone';
import {NgbDatepicker, NgbDatepickerI18n, NgbDateStruct, NgbDropdown} from "@ng-bootstrap/ng-bootstrap";
import {ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR} from "@angular/forms";

@Injectable()
export class I18n {
	language = 'ru';
	I18N_VALUES = {
		'ru': {
			weekdays: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
			months: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
		}
	};
}

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
	constructor(private _i18n: I18n) {
		super();
	}	
	
	getWeekdayShortName(weekday: number): string {
		return this._i18n.I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
	}	
	
	getMonthShortName(month: number): string {
		return this._i18n.I18N_VALUES[this._i18n.language].months[month - 1];
	}	
	
	getMonthFullName(month: number): string {
		return this.getMonthShortName(month);
	}

	getDayAriaLabel(date: NgbDateStruct): string {
		return `${date.year}-${date.month}-${date.day}`;
	}
}

@Component({
	selector: 'datetimepicker',
	template: `
		<div class="d-inline-block" ngbDropdown #myDropdown="ngbDropdown" [autoClose]="'outside'">
			<input
			    ngbDropdownToggle
			    class="form-control"
			    [(ngModel)]="dt"
			    (input)="onInput($event)"
			    (click)="onInputClick($event);"
			    [disabled]="disabled"
			   />
			
			<span class="fa fa-calendar-alt" aria-hidden="true" (click)="onInputClick($event);"></span>
			
			<div ngbDropdownMenu>
				<ngb-datepicker
					#myDatepicker
					[firstDayOfWeek]="1"
					[(ngModel)]="modelD"
					(click)="onDatepickerClick($event)"
					[disabled]="disabled"
					[minDate]="minDate"
					[maxDate]="maxDate"
				></ngb-datepicker>
				
				<div style="clear: both;"></div>

				<div class="card" *ngIf="enabledTime">
					<div class="card-block">
						<div class="row">
							<div class="col">&nbsp;</div>
							<div class="col-md-auto">
								<a href="#" (click)="$event.preventDefault(); showTimepicker();">&#9200;</a>
							</div>
							<div class="col">&nbsp;</div>
						</div>
						<div class="row" *ngIf="visibleTimepicker">
							<div class="col">&nbsp;</div>
							<div class="col-md-auto">
								<ngb-timepicker [(ngModel)]="modelT" [minuteStep]="30" [size]="'small'"></ngb-timepicker>
							</div>
							<div class="col">&nbsp;</div>
						</div>
					</div>
				</div>
			</div>
		</div>`,
	styles: [`
		.dropdown-menu {
			padding: 0 !important;
		}

		:host >>> .d-inline-block {
			display: block !important;
		}
    
		:host >>> ngb-timepicker .btn-link {
			border-color: transparent !important;
		}

		:host >>> ngb-datepicker .btn-link {
			border-color: transparent !important;
		}

		:host >>> .fa-calendar-alt {
			width: 15px;
			margin: -27px 10px;
			float: right;
		}`],
	providers: [
		I18n, 
		{provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n},
		{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DatetimepickerComponent), multi: true }
	]
})
export class DatetimepickerComponent implements ControlValueAccessor, OnInit {
	propagateChange: any = () => {};

	@Input() dt: string = moment().format('DD-MM-YYYY');
	@Output() dtChange: EventEmitter<string> = new EventEmitter<string>();
	@Input() format: string = 'YYYY-MM-DD';//'DD.MM.YYYY HH:mm';
	@Input() enabledTime: boolean = false;
	@Input() disabled: boolean = false;
	@Input() minDate: NgbDateStruct;
	@Input() maxDate: NgbDateStruct = {year: 3000, month: 12, day: 31};

	modelD: NgbDateStruct = {
		year: 2017,
		month: 11,
		day: 8
	};
	modelT: any = {
		hour: 0,
		minute: 0
	};

	visibleTimepicker: boolean = false;

	@ViewChild('myDropdown', { static: true })
	private myDropdown: NgbDropdown;

	@ViewChild('myDatepicker', { static: true })
	private myDatepicker: NgbDatepicker;

	ngOnInit() {
		/*
		if(!this.minDate) {
			const dt = moment();
			this.minDate = {year: dt.year(), month: dt.month() + 1, day: dt.date()};
		}
		*/

		if (this.enabledTime) {
			const dt = moment(this.dt, this.format);
			
			this.modelD = {year: dt.year(), month: dt.month() + 1, day: dt.date()};
			this.modelT = {hour: dt.hour(), minute: dt.minute()};

			this.visibleTimepicker = true;
		} else if (this.dt && this.dt.length == 10) {
			const dt = moment(this.dt, this.format);
			
			this.modelD = {year: dt.year(), month: dt.month() + 1, day: dt.date()};

			this.visibleTimepicker = false;
		} else {
			const dt = moment();

			this.modelD = {year: dt.year(), month: dt.month() + 1, day: dt.date()};

			this.visibleTimepicker = false;
		}
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.dt && changes.dt.currentValue != '') {
			const dt = moment(this.dt, this.format);

			this.modelD = {year: dt.year(), month: (dt.month() + 1), day: dt.date()};

			this.myDatepicker.navigateTo({
				year: this.modelD.year,
				month: this.modelD.month
			});
		}
	}

	showTimepicker() {
		this.visibleTimepicker = !this.visibleTimepicker;
	}

	onInputClick(event) {
		event.stopPropagation();

		if (this.disabled) {
			return;
		}

		this.myDropdown.open();

		this.myDatepicker.navigateTo(this.modelD);
	}

	onDatepickerClick(event) {
		if (event.target.className.indexOf('bg-primary') != -1) {
			this.myDropdown.close();

			let dt = moment([this.modelD.year, (this.modelD.month - 1), this.modelD.day]);

			if (this.visibleTimepicker && this.modelT.hour != null) {
				dt.hour(this.modelT.hour);
				dt.minute(this.modelT.minute);

				this.dt = dt.format(this.format);
			} else {
				this.dt = dt.format(this.format);
			}

			this.dtChange.emit(this.dt);

			this.propagateChange(this.dt);
		}
	}

	writeValue(value) {
		if (value) {
			this.dt = value;
		}
	}

	registerOnChange(fn) {
		this.propagateChange = fn;
	}

	registerOnTouched() {

	}

	// Не до конца понятно почему без явного отслеживания (input), при ручном вводе значения, не меняется dt
	onInput(event) {
		this.dt = event.target.value;
	}
}
